import { render, staticRenderFns } from "./AvatarBuilderUI.vue?vue&type=template&id=67564e94&scoped=true&"
import script from "./AvatarBuilderUI.vue?vue&type=script&lang=js&"
export * from "./AvatarBuilderUI.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBuilderUI.vue?vue&type=style&index=0&id=67564e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67564e94",
  null
  
)

export default component.exports